#import '../queries/UserDetails.graphql'
mutation Impersonate($username: String!) {
  impersonate(username: $username) {
    ok
    errors
    user {
      id
      ...userDetails
    }
  }
}
